import { render, staticRenderFns } from "./send-contact-dialog.vue?vue&type=template&id=30d2168c&scoped=true&"
import script from "./send-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./send-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-contact-dialog.vue?vue&type=style&index=0&id=30d2168c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2168c",
  null
  
)

export default component.exports